export default __webpack_public_path__ + "static/media/user_poap_01.1a123432.svg";